import React from 'react';
import './selectField.less';
import { Select, DropdownItemProps, DropdownProps } from 'semantic-ui-react';

// [Component Usage]
// <Field
// component={SelectField}
// options={[
// 	{ key: 'Todos', value: 'Todos', text: 'Todos' },
// 	{ key: 'Todos1', value: 'Todos1', text: 'Todos1' },
// 	{ key: 'Todos2', value: 'Todos2', text: 'Todos2' },
// ]}
// value="Todos"
// placeholder="Selecione"
// selectFieldLabel="Destinatário(NIF - NOME ENTIDADE)"
// onChange={(event: React.SyntheticEvent<HTMLElement>, data: DropdownProps): void => {
// 	setFieldValue('to', data.value, false);
// }}
export interface SelectFieldInnerProps {
	/* Options that will be shown in the SelectField */
	options: DropdownItemProps[];
	/* Placeholder shown when no value is selected  */
	placeholder?: string;
	/** Label Shown */
	selectFieldLabel?: string;
	/** Boolean for controlling if is required or not */
	isRequired?: boolean;
	/** Default value of selected option */
	defaultValue?: string | number;
	/** Default value of selected option */
	value?: string | number;
	/* Method on change - when a option is selected the value is refreshed  */
	onChange?: (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => void;
	/** Boolean for controlling if exist or not an error */
	hasError?: boolean;
	/** Error message shown in case it exists any */
	errorMessage?: string;
	/** Boolean for controlling if the input is disabled or not */
	isDisabled?: boolean;
}

type SelectFieldProps = SelectFieldInnerProps;

export const SelectField: React.FC<SelectFieldProps> = (props: SelectFieldProps): JSX.Element => {
	const {
		options,
		placeholder,
		defaultValue,
		onChange,
		selectFieldLabel,
		hasError = false,
		errorMessage = '',
		isDisabled = false,
		isRequired = false,
		value,
	} = props;
	return (
		<div className="ds-select-field">
			<label className={`selectFieldLabel ${isRequired ? 'required' : ''}`}>{selectFieldLabel}</label>
			<div className="ds-dropdown">
				<Select
					options={options}
					placeholder={placeholder}
					defaultValue={defaultValue}
					value={value}
					onChange={onChange}
					disabled={isDisabled}
				></Select>
			</div>
			<div className="input-error-text">
				<span>{`${hasError ? errorMessage : ''}`}</span>
			</div>
		</div>
	);
};
